const clinicType = process.env.REACT_APP_CETRA_CLINIC_TYPE || 'physio';
const isProd = process.env.REACT_APP_USER_API_URL?.includes('prod');

// Mixpanel tokens - same as main apps for unified analytics
const mixpanelTokens = {
    physio: {
        prod: '189e32a152f429590258281c65ec1492',
        dev: '3670bd50f368dec66e70e31dd0090f8e',
    },
    vet: {
        prod: 'cf4c559bb22f7ba78ba1667adc6bdbe4',
        dev: 'b9a4fc257db382b75fb35c9011ff6f98',
    },
};

const config = {
    clinicType,
    isProd,
    mixpanelToken: mixpanelTokens[clinicType]?.[isProd ? 'prod' : 'dev'] || null,
};

export default config;